module.exports = __webpack_public_path__ + "img/italy-cancer-female.aeda27e8.png";